(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/game-list-new/assets/javascripts/hooks/use-get-game-url.js') >= 0) return;  svs.modules.push('/components/marketplace/game-list-new/assets/javascripts/hooks/use-get-game-url.js');

'use strict';

const {
  getGameAriaLabel
} = svs.components.marketplace.helpers.games;
const {
  getTeamUrl,
  getRetailUrl
} = svs.components.marketplace.helpers;
const useGetGameUrl = function (game) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    groupId,
    groupName,
    isRetail = false,
    isListing = false,
    fromTeamList = false,
    gameLinkSearch = '',
    location = null
  } = options;
  const isCurrentUserAuthenticated = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  if (!game || !game.activatedDrawId || !game.containerId) {
    return {
      url: null,
      ariaLabel: null
    };
  }
  const {
    activatedDrawId,
    containerId
  } = game;

  const linkTo = isRetail ? getRetailUrl(groupId, groupName, 'spel', containerId, activatedDrawId) : getTeamUrl(groupId, groupName, 'spel', containerId, activatedDrawId);
  let queryString = '';
  if (gameLinkSearch) {
    queryString = "?".concat(gameLinkSearch);
  } else if (location && location.search) {
    queryString = "?".concat(location.search);
  }
  const routeUrl = fromTeamList ? "".concat(linkTo).concat(queryString) : linkTo;
  const finalUrl = routeUrl;

  const ariaLabel = getGameAriaLabel({
    game,
    groupId,
    isCurrentUserAuthenticated,
    isListing,
    isRetail
  });
  return {
    url: finalUrl,
    ariaLabel
  };
};
setGlobal('svs.components.marketplace.gameListNew.hooks.useGetGameUrl', useGetGameUrl);

 })(window);